<template>
  <div class="AccountSettingModal">
    <el-dialog
        title="账号设置"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="30%"
        :center="true"
        @open="handleOpen"
    >
      <el-form :model="formData" ref="form" :rules="rules" label-width="90px">
        <el-form-item label="上传头像">
          <el-upload
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-success="handleAvatarSuccess"
              :on-change="handleImgChange"
              :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" alt=""/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div>
              <el-button
                  class="btn"
                  v-if="imageUrl"
                  size="mini"
                  plain
                  type="primary"
                  slot="trigger"
              >上传更换
              </el-button>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="用户名" prop="nickname">
          <el-input v-model="formData.nickname"></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="formData.phone" disabled></el-input>
        </el-form-item>
        <el-form-item label="设置密码" prop="password">
          <el-input v-model="formData.password" show-password placeholder="*********"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="passwordTwice">
          <el-input v-model="formData.passwordTwice" show-password placeholder="*********"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button
            plain
            size="small"
            style="width: 30%; display: inline-block"
            type="primary"
            @click="handleClose"
        >取消</el-button
        >
        <el-button
            size="small"
            style="width: 30%; display: inline-block"
            type="primary"
            @click="handleConfirm"
        >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "AccountSettingModal",
  data() {
    let checkPwd = (rule, value, callback) => {
      if (value !== this.formData.password) {
        callback(new Error("两次密码输入不一致"));
      } else {
        callback();
      }
    };
    return {
      imageUrl: "",
      formData: {
        avatar: "",
        id: null,
        nickname: "",
        password: null,
        passwordTwice: null,
        phone: "",
      },
      rules: {
        nickname: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            pattern: /^(?=.*[A-Za-z])(?=.*[0-9])[A-Za-z0-9]{6,15}$/,
            message: "请输入(6-15)位字母数字组合",
            trigger: ["blur", "change"],
          },
        ],
        passwordTwice: [
          {
            validator: checkPwd,
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("user", ["accountSettingModalVisible", "userInfo"]),
    ...mapState("tenant", ["ossUploadObj"]),
    visible: {
      get() {
        return this.$store.state.user.accountSettingModalVisible;
      },
      set(value) {
        this.$store.commit("user/setData", {
          key: "accountSettingModalVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapMutations("user", ["setData"]),
    ...mapActions("user", ["updateUserInfo", "getUserInfo"]),
    ...mapActions("tenant", ["generalUploadUrl"]),
    async handleImgChange(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      this.formData.avatar = this.ossUploadObj.filename;
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            console.log(res);
          })
          .catch((e) => {
            console.log(e);
          });
      this.$axios.defaults.withCredentials = true;
    },
    async handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleClose() {
      this.setData({key: "accountSettingModalVisible", value: false});
    },
    handleOpen() {
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      Object.keys(this.formData).map((key) => {
        this.formData[key] = this.userInfo[key];
      });
      this.formData.passwordTwice = this.userInfo.password;
      this.imageUrl = this.userInfo.avatar;
      this.formData.avatar = null;
    },
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.setData({key: "accountSettingModalVisible", value: false});
          await this.$refs.form.validate(async (valid) => {
            if (valid) {
              await this.updateUserInfo({
                ...this.formData,
              });
              await this.getUserInfo();
              this.$message.success("操作成功");
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.AccountSettingModal {
  ::v-deep .el-dialog {
    min-width: 420px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px solid #dcdfe6;
    border-radius: 50%;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
    border-radius: 50%;
  }

  .btn {
    text-align: right;
  }
}
</style>
